/**
 * Logging utility for environment-aware logging
 * In production, logs are disabled to prevent information leakage
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';

// Only log in development and test environments
const shouldLog = isDevelopment || isTest;

export const logger = {
  log: (...args) => {
    if (shouldLog) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    if (shouldLog) {
      console.error(...args);
    } else {
      // In production, you might want to send to error tracking service
      // Example: Sentry.captureException(args[0]);
    }
  },
  
  warn: (...args) => {
    if (shouldLog) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (shouldLog) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (shouldLog) {
      console.debug(...args);
    }
  },
  
  table: (...args) => {
    if (shouldLog && console.table) {
      console.table(...args);
    }
  }
};

// Export individual functions for convenience
export const { log, error, warn, info, debug, table } = logger;

export default logger;
